import React from 'react';
import PropTypes from 'prop-types';
import { keywordList } from '../../../utility/AlertNotificationTemplateUtils';

function TemplateKeywordsBox({ handleSetKeyword, maxHeight = '300px' }) {
  const handleKeywordClick = (e, keyword) => {
    e.preventDefault();
    handleSetKeyword(keyword);
  };

  return (
    <div
      className="keywords-container"
      style={{
        maxHeight,
        overflowY: 'auto',
        border: '1px solid #ddd',
        borderRadius: '5px',
      }}
    >
      <div className="keywords-list">
        {Object.entries(keywordList).map(([keyword, value], index) => (
          <div
            key={keyword}
            className={`keyword-item p-2 ${index % 2 === 0 ? 'bg-light' : ''}`}
            style={{
              borderBottom: index < Object.keys(keywordList).length - 1
                ? '1px solid #e9ecef'
                : 'none',
            }}
          >
            <button
              type="button"
              className="btn btn-link p-0 text-left w-100"
              onClick={(e) => handleKeywordClick(e, keyword)}
              style={{ textDecoration: 'none', fontWeight: 'bold' }}
            >
              {keyword}
            </button>
            <small className="text-muted text-left d-block">{value.description}</small>
          </div>
        ))}
      </div>
    </div>
  );
}

TemplateKeywordsBox.propTypes = {
  handleSetKeyword: PropTypes.func.isRequired,
  maxHeight: PropTypes.string.isRequired,
};

export { TemplateKeywordsBox };
export default TemplateKeywordsBox;
